module.exports = __webpack_public_path__ + "static/img/tu3.c64decb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/tu3.png
// module id = rEad
// module chunks = 1